<template>
  <div class="match-2022p">
    <div id="app" style="min-width: 1160px; position: relative">
      <el-row
        class="bannerP-0204"
        onclick='javascript:window.open("http://univ.ciciec.com/col.jsp?id=116","_blank")'
      >
      </el-row>
      <!-- 赛事简洁 -->
      <el-row class="pd60-0204 fpga-wrapper" id="ssjj-mlj">
        <el-row class="w1160-0204">
          <el-row class="title-font28-0204">赛事简介</el-row>
          <el-row class="title-bgimg-0204"></el-row>
          <div class="ins-box">
            <img
              class="fpga-ins-img"
              src="@/assets/myMatch/ciciec2022/introduce20220314.png"
              alt=""
            />
            <el-row class="ins-text-fpga">
              <div>
                2022年1月中旬，海云捷迅执行承办的第六届全国大学生集成电路创新创业大赛启动仪式在线上举行。该活动由工业和信息化部人才交流中心主办，重庆西永微电子产业园区承办，示范性微电子学院产学融合发展联盟、IEEE中国代表处、北京电子学会协办，北京智芯国信科技有限公司运营。
              </div>
              <br />
              <div>
                作为本次大赛的执行承办方，海云捷迅将提供人工智能边缘实验平台作为本次大赛的赛事平台，并参与赛题设置。海云捷迅将倾力参与到大赛中，为参赛团队提供服务。
              </div>
            </el-row>
          </div>
        </el-row>
      </el-row>
      <!-- 精彩资讯 -->
      <el-row class="pd60-0204" id="jczx-mlj" style="background-color: #f5f6f9">
        <el-row class="w1160-0204">
          <el-row class="title-font28-0204">精彩资讯</el-row>
          <el-row class="title-bgimg-0204"></el-row>
          <el-row class="title-text-0204" style="color: #999999"
            >实时传递大赛最新动态</el-row
          >
          <div style="display: flex">
            <div class="lbt-btn">
              <i class="icon iconfont icon-fj-chevron-left"></i>
            </div>
            <div class="swiper-container" style="margin: 0 10px">
              <div class="swiper-wrapper">
                <!-- 2022-10-9 增加内容 -->
                <div class="swiper-slide">
                  <div
                    class="lbt-li-0204"
                    onclick="javascript:window.open('https://www.awcloud.com/news_detail.html?id=5155','_blank')"
                  >
                    <div class="top">
                      <img
                        src="@/assets/myMatch/ciciec2022/202210092.jpg"
                        height="227px"
                      />
                    </div>
                    <div class="bottom">
                      <div
                        class="title"
                        title="第六届集创赛“海云捷迅杯”全国总决赛获奖名单公布"
                      >
                        第六届集创赛“海云捷迅杯”全国总决赛获奖名单公布
                      </div>
                      <div class="date">2022-09-08</div>
                      <div
                        class="description"
                        title="全国总决赛获奖名单公布（盖章版）"
                      >
                        全国总决赛获奖名单公布（盖章版）
                      </div>
                      <div class="description"><br /></div>
                      <div class="description"><br /></div>
                    </div>
                  </div>
                </div>

                <div class="swiper-slide">
                  <div
                    class="lbt-li-0204"
                    onclick="javascript:window.open('https://www.awcloud.com/news_detail.html?id=5137','_blank')"
                  >
                    <div class="top">
                      <img
                        src="@/assets/myMatch/ciciec2022/202210092.jpg"
                        height="227px"
                      />
                    </div>
                    <div class="bottom">
                      <div
                        class="title"
                        title="第六届集创赛“海云捷迅杯”全国总决赛答辩评审在重庆顺利举行"
                      >
                        第六届集创赛“海云捷迅杯”全国总决赛答辩评审在重庆顺利举行
                      </div>
                      <div class="date">2022-08-26</div>
                      <div
                        class="description"
                        title="第六届全国大学生集成电路创新创业大赛“海云捷迅杯”全国总决赛答辩评审在重庆以线上方式举行"
                      >
                        第六届全国大学生集成电路创新创业大赛“海云捷迅杯”全国总决赛答辩评审在重庆以线上方式举行
                      </div>
                      <div class="description"><br /></div>
                    </div>
                  </div>
                </div>

                <div class="swiper-slide">
                  <div
                    class="lbt-li-0204"
                    onclick="javascript:window.open('https://www.awcloud.com/news_detail.html?id=5077','_blank')"
                  >
                    <div class="top">
                      <img
                        src="@/assets/myMatch/ciciec2022/202210091.jpg"
                        height="227px"
                      />
                    </div>
                    <div class="bottom">
                      <div
                        class="title"
                        title="赛事转播！集创赛分赛区决赛进行时…"
                      >
                        赛事转播！集创赛分赛区决赛进行时…
                      </div>
                      <div class="date">2022-07-25</div>
                      <div
                        class="description"
                        title="第六届全国大学生集成电路创新创业大赛西南分赛区决赛的成功举办正式拉开决赛序幕"
                      >
                        第六届全国大学生集成电路创新创业大赛西南分赛区决赛的成功举办正式拉开决赛序幕
                      </div>
                      <div class="description"><br /></div>
                    </div>
                  </div>
                </div>
                <!-- 2022-8-19 -->
                <div class="swiper-slide">
                  <div
                    class="lbt-li-0204"
                    onclick="javascript:window.open('https://www.awcloud.com/news_detail.html?id=5124','_blank')"
                  >
                    <div class="top">
                      <img
                        src="@/assets/myMatch/ciciec2022/2022081901.jpg"
                        height="227px"
                      />
                    </div>
                    <div class="bottom">
                      <div
                        class="title"
                        title="海云捷迅杯全国总决赛答辩序号公示"
                      >
                        海云捷迅杯全国总决赛答辩序号公示
                      </div>
                      <div class="date">2022-08-14</div>
                      <div
                        class="description"
                        title="海云捷迅杯全国总决赛答辩序号公示"
                      >
                        海云捷迅杯全国总决赛答辩序号公示
                      </div>
                      <div class="description"><br /></div>
                    </div>
                  </div>
                </div>

                <div class="swiper-slide">
                  <div
                    class="lbt-li-0204"
                    onclick="javascript:window.open('https://www.awcloud.com/news_detail.html?id=5120','_blank')"
                  >
                    <div class="top">
                      <img
                        src="@/assets/myMatch/ciciec2022/2022081902.jpg"
                        height="227px"
                      />
                    </div>
                    <div class="bottom">
                      <div class="title" title="全国总决赛参赛补充说明">
                        全国总决赛参赛补充说明
                      </div>
                      <div class="date">2022-08-12</div>
                      <div class="description" title="全国总决赛参赛补充说明">
                        全国总决赛参赛补充说明
                      </div>
                      <div class="description"><br /></div>
                    </div>
                  </div>
                </div>

                <div class="swiper-slide">
                  <div
                    class="lbt-li-0204"
                    onclick="javascript:window.open('https://www.awcloud.com/news_detail.html?id=5122','_blank')"
                  >
                    <div class="top">
                      <img
                        src="@/assets/myMatch/ciciec2022/2022081903.jpg"
                        height="227px"
                      />
                    </div>
                    <div class="bottom">
                      <div
                        class="title"
                        title="海云捷迅杯全国总决赛杯赛作品和答辩要求"
                      >
                        海云捷迅杯全国总决赛杯赛作品和答辩要求
                      </div>
                      <div class="date">2022-08-11</div>
                      <div
                        class="description"
                        title="海云捷迅杯全国总决赛杯赛作品和答辩要求"
                      >
                        海云捷迅杯全国总决赛杯赛作品和答辩要求
                      </div>
                      <div class="description"><br /></div>
                    </div>
                  </div>
                </div>
                <!-- 2022-7-18 增加内容 -->
                <div class="swiper-slide">
                  <div
                    class="lbt-li-0204"
                    onclick="javascript:window.open('https://www.awcloud.com/news_detail.html?id=5053','_blank')"
                  >
                    <div class="top">
                      <img
                        src="@/assets/myMatch/ciciec2022/2022071803.jpg"
                        height="227px"
                      />
                    </div>
                    <div class="bottom">
                      <div
                        class="title"
                        title="第六届集创赛西南分赛区决赛成功举办"
                      >
                        第六届集创赛西南分赛区决赛成功举办
                      </div>
                      <div class="date">2022-07-13</div>
                      <div
                        class="description"
                        title="第六届集创赛西南分赛区决赛成功举办。"
                      >
                        第六届集创赛西南分赛区决赛成功举办。
                      </div>
                      <div class="description"><br /></div>
                    </div>
                  </div>
                </div>
                <div class="swiper-slide">
                  <div
                    class="lbt-li-0204"
                    onclick="javascript:window.open('https://www.awcloud.com/news_detail.html?id=5022','_blank')"
                  >
                    <div class="top">
                      <img
                        src="@/assets/myMatch/ciciec2022/2022071802.jpg"
                        height="227px"
                      />
                    </div>
                    <div class="bottom">
                      <div
                        class="title"
                        title="第六届集创赛西南分赛区决赛获奖名单"
                      >
                        第六届集创赛西南分赛区决赛获奖名单
                      </div>
                      <div class="date">2022-07-11</div>
                      <div
                        class="description"
                        title="第六届集创赛西南分赛区决赛获奖名单公布"
                      >
                        第六届集创赛西南分赛区决赛获奖名单公布
                      </div>
                      <div class="description"><br /></div>
                    </div>
                  </div>
                </div>
                <div class="swiper-slide">
                  <div
                    class="lbt-li-0204"
                    onclick="javascript:window.open('https://www.awcloud.com/news_detail.html?id=5049','_blank')"
                  >
                    <div class="top">
                      <img
                        src="@/assets/myMatch/ciciec2022/2022071801.jpg"
                        height="227px"
                      />
                    </div>
                    <div class="bottom">
                      <div
                        class="title"
                        title="海云捷迅受邀参加第一届集成电路产学研融合交流会"
                      >
                        海云捷迅受邀参加第一届集成电路产学研融合交流会
                      </div>
                      <div class="date">2022-07-11</div>
                      <div
                        class="description"
                        title="海云捷迅受邀参加第一届集成电路产学研融合交流会"
                      >
                        海云捷迅受邀参加第一届集成电路产学研融合交流会
                      </div>
                      <div class="description"><br /></div>
                    </div>
                  </div>
                </div>
                <!-- 2022-7-11 增加内容 -->
                <div class="swiper-slide">
                  <div
                    class="lbt-li-0204"
                    onclick="javascript:window.open('https://www.awcloud.com/news_detail.html?id=5014','_blank')"
                  >
                    <div class="top">
                      <img
                        src="@/assets/myMatch/ciciec2022/20220711.jpg"
                        height="227px"
                      />
                    </div>
                    <div class="bottom">
                      <div
                        class="title"
                        title="【重要通知】第六届集创赛分赛区决赛答辩顺序公示"
                      >
                        【重要通知】第六届集创赛分赛区决赛答辩顺序公示
                      </div>
                      <div class="date">2022-07-05</div>
                      <div
                        class="description"
                        title="第六届集创赛分赛区决赛答辩顺序公示-西南赛区"
                      >
                        第六届集创赛分赛区决赛答辩顺序公示-西南赛区
                      </div>
                      <div class="description"><br /></div>
                    </div>
                  </div>
                </div>
                <!-- 2022-6-27 增加内容 -->
                <div class="swiper-slide">
                  <div
                    class="lbt-li-0204"
                    onclick="javascript:window.open('https://www.awcloud.com/news_detail.html?id=5002','_blank')"
                  >
                    <div class="top">
                      <img
                        src="@/assets/myMatch/ciciec2022/2022070502.jpg"
                        height="227px"
                      />
                    </div>
                    <div class="bottom">
                      <div
                        class="title"
                        title="【重要通知】第六届集创赛西南分赛区决赛通知"
                      >
                        【重要通知】第六届集创赛西南分赛区决赛通知
                      </div>
                      <div class="date">2022-06-28</div>
                      <div
                        class="description"
                        title="第六届集创赛西南分赛区决赛通知"
                      >
                        第六届集创赛西南分赛区决赛通知
                      </div>
                      <div class="description"><br /></div>
                    </div>
                  </div>
                </div>
                <div class="swiper-slide">
                  <div
                    class="lbt-li-0204"
                    onclick="javascript:window.open('https://www.awcloud.com/news_detail.html?id=5000','_blank')"
                  >
                    <div class="top">
                      <img
                        src="@/assets/myMatch/ciciec2022/2022070501.jpg"
                        height="227px"
                      />
                    </div>
                    <div class="bottom">
                      <div class="title" title="第六届集创赛分赛区决赛答辩要求">
                        第六届集创赛分赛区决赛答辩要求
                      </div>
                      <div class="date">2022-06-27</div>
                      <div
                        class="description"
                        title="第六届集创赛分赛区海云捷迅杯决赛答辩要求"
                      >
                        第六届集创赛分赛区海云捷迅杯决赛答辩要求
                      </div>
                      <div class="description"><br /></div>
                    </div>
                  </div>
                </div>
                <!-- 2022-6-27 增加内容 -->
                <div class="swiper-slide">
                  <div
                    class="lbt-li-0204"
                    onclick="javascript:window.open('https://www.awcloud.com/news_detail.html?id=4996','_blank')"
                  >
                    <div class="top">
                      <img
                        src="@/assets/myMatch/ciciec2022/2022062701.jpg"
                        height="227px"
                      />
                    </div>
                    <div class="bottom">
                      <div class="title" title="第六届集创赛初赛晋级名单公示">
                        第六届集创赛初赛晋级名单公示
                      </div>
                      <div class="date">2022-06-23</div>
                      <div class="description" title="初赛晋级名单公示">
                        初赛晋级名单公示
                      </div>
                      <div class="description"><br /></div>
                    </div>
                  </div>
                </div>
                <!-- 2022-6-15 增加内容 -->
                <div class="swiper-slide">
                  <div
                    class="lbt-li-0204"
                    onclick="javascript:window.open('https://www.awcloud.com/news_detail.html?id=4972','_blank')"
                  >
                    <div class="top">
                      <img
                        src="@/assets/myMatch/ciciec2022/2022061503.jpg"
                        height="227px"
                      />
                    </div>
                    <div class="bottom">
                      <div
                        class="title"
                        title="第六届集创赛初赛作品提交时间延期通知"
                      >
                        第六届集创赛初赛作品提交时间延期通知
                      </div>
                      <div class="date">2022-06-01</div>
                      <div
                        class="description"
                        title="第六届集创赛初赛作品提交时间延期通知"
                      >
                        第六届集创赛初赛作品提交时间延期通知
                      </div>
                      <div class="description"><br /></div>
                    </div>
                  </div>
                </div>
                <div class="swiper-slide">
                  <div
                    class="lbt-li-0204"
                    onclick="javascript:window.open('https://www.awcloud.com/news_detail.html?id=4966','_blank')"
                  >
                    <div class="top">
                      <img
                        src="@/assets/myMatch/ciciec2022/2022061502.jpg"
                        height="227px"
                      />
                    </div>
                    <div class="bottom">
                      <div
                        class="title"
                        title="第六届全国大学生集成电路创新创业大赛 初赛通知"
                      >
                        第六届全国大学生集成电路创新创业大赛 初赛通知
                      </div>
                      <div class="date">2022-05-13</div>
                      <div class="description" title="初赛通知">初赛通知</div>
                      <div class="description"><br /></div>
                    </div>
                  </div>
                </div>
                <div class="swiper-slide">
                  <div
                    class="lbt-li-0204"
                    onclick="javascript:window.open('https://www.awcloud.com/news_detail.html?id=4969','_blank')"
                  >
                    <div class="top">
                      <img
                        src="@/assets/myMatch/ciciec2022/2022061501.jpg"
                        height="227px"
                      />
                    </div>
                    <div class="bottom">
                      <div
                        class="title"
                        title="第六届集创赛 初赛通知附件1：初赛作品提交内容"
                      >
                        第六届集创赛 初赛通知附件1：初赛作品提交内容
                      </div>
                      <div class="date">2022-05-13</div>
                      <div class="description" title="初赛作品提交内容通知">
                        初赛作品提交内容通知
                      </div>
                      <div class="description"><br /></div>
                    </div>
                  </div>
                </div>
                <!-- 2022-5-30 增加内容 -->
                <div class="swiper-slide">
                  <div
                    class="lbt-li-0204"
                    onclick="javascript:window.open('https://www.awcloud.com/news_detail.html?id=4944','_blank')"
                  >
                    <div class="top">
                      <img
                        src="@/assets/myMatch/ciciec2022/20220530.png"
                        height="227px"
                      />
                    </div>
                    <div class="bottom">
                      <div
                        class="title"
                        title="速度收藏！第六届集创赛海云捷迅杯得分要点总结？！"
                      >
                        速度收藏！第六届集创赛海云捷迅杯得分要点总结？！
                      </div>
                      <div class="date">2022-05-20</div>
                      <div
                        class="description"
                        title="第六届集创赛海云捷迅杯赛题详细解读。"
                      >
                        第六届集创赛海云捷迅杯赛题详细解读
                      </div>
                      <div class="description"><br /></div>
                    </div>
                  </div>
                </div>
                <!-- 2022-5-2 增加内容 -->
                <div class="swiper-slide">
                  <div
                    class="lbt-li-0204"
                    onclick="javascript:window.open('https://www.awcloud.com/news_detail.html?id=4907','_blank')"
                  >
                    <div class="top">
                      <img
                        src="@/assets/myMatch/ciciec2022/20220502.jpg"
                        height="227px"
                      />
                    </div>
                    <div class="bottom">
                      <div
                        class="title"
                        title="集创赛人才节开启，创芯专场，海云捷迅招聘等你来。"
                      >
                        集创赛人才节开启，创芯专场，海云捷迅招聘等你来。
                      </div>
                      <div class="date">2022-04-20</div>
                      <div
                        class="description"
                        title="【集创赛·人才节】JOIN US！创芯春季专场 虚位以待！"
                      >
                        【集创赛·人才节】JOIN US！创芯春季专场 虚位以待！
                      </div>
                    </div>
                  </div>
                </div>
                <div class="swiper-slide">
                  <div
                    class="lbt-li-0204"
                    onclick="javascript:window.open('https://www.awcloud.com/news_detail.html?id=4872','_blank')"
                  >
                    <div class="top">
                      <img
                        src="@/assets/myMatch/ciciec2022/202203211.jpg"
                        height="227px"
                      />
                    </div>
                    <div class="bottom">
                      <div
                        class="title"
                        title="【直播回顾】第六届集创赛海云捷迅杯赛题答疑，你想了解的都在这里~"
                      >
                        【直播回顾】第六届集创赛海云捷迅杯赛题答疑，你想了解的都在这里~
                      </div>
                      <div class="date">2022-03-18</div>
                      <div
                        class="description"
                        title="第六届集创赛海云捷迅杯赛题答疑"
                      >
                        第六届集创赛海云捷迅杯赛题答疑
                      </div>
                      <div class="description"><br /></div>
                    </div>
                  </div>
                </div>
                <div class="swiper-slide">
                  <div
                    class="lbt-li-0204"
                    onclick="javascript:window.open('https://www.awcloud.com/news_detail.html?id=4862','_blank')"
                  >
                    <div class="top">
                      <img
                        src="@/assets/myMatch/ciciec2022/20220321.jpg"
                        height="227px"
                      />
                    </div>
                    <div class="bottom">
                      <div
                        class="title"
                        title="“芯成大海，壮志凌云——海云捷迅杯FPGA与AI双剑合璧助你练就正宗芯法"
                      >
                        芯成大海，壮志凌云——海云捷迅杯FPGA与AI双剑合璧助你练就正宗芯法
                      </div>
                      <div class="date">2022-03-15</div>
                      <div
                        class="description"
                        title="第六届集创赛海云捷迅杯赛题解析"
                      >
                        第六届集创赛海云捷迅杯赛题解析
                      </div>
                      <div class="description"><br /></div>
                    </div>
                  </div>
                </div>
                <!-- 2022-1-18 增加内容 -->
                <div class="swiper-slide">
                  <div
                    class="lbt-li-0204"
                    onclick="javascript:window.open('https://www.awcloud.com/news_detail.html?id=4778','_blank')"
                  >
                    <div class="top">
                      <img
                        src="@/assets/myMatch/ciciec2022/20220118.jpg"
                        height="227px"
                      />
                    </div>
                    <div class="bottom">
                      <div
                        class="title"
                        title="“芯”随意动，报名第六届集创赛，“海云捷迅杯”再次开启“芯”一年！"
                      >
                        “芯”随意动，报名第六届集创赛，“海云捷迅杯”再次开启“芯”一年！
                      </div>
                      <div class="date">2022-01-14</div>
                      <div
                        class="description"
                        title="第六届集创赛“海云捷迅杯”开启报名"
                      >
                        第六届集创赛“海云捷迅杯”开启报名
                      </div>
                      <div class="description"><br /></div>
                    </div>
                  </div>
                </div>
                <!-- 2022-1-12 增加内容 -->
                <div class="swiper-slide">
                  <div
                    class="lbt-li-0204"
                    onclick="javascript:window.open('https://www.awcloud.com/news_detail.html?id=4753','_blank')"
                  >
                    <div class="top">
                      <img
                        src="@/assets/myMatch/ciciec2022/20220112资讯1.png"
                        height="227px"
                      />
                    </div>
                    <div class="bottom">
                      <div
                        class="title"
                        title="第六届全国大学生集成电路创新创业大赛扬帆在即"
                      >
                        第六届全国大学生集成电路创新创业大赛扬帆在即
                      </div>
                      <div class="date">2022-01-12</div>
                      <div
                        class="description"
                        title="1月12日10:00~11:30  第六届集创赛启动仪式将在线上进行。"
                      >
                        1月12日10:00~11:30 第六届集创赛启动仪式将在线上进行。
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="lbt-btn">
              <i class="icon iconfont icon-fj-chevron-right"></i>
            </div>
          </div>
          <el-row style="margin-top: 30px">
            <div class="title-button">
              <a
                href="http://univ.ciciec.com"
                target="_blank"
                class="title-link"
                >进入集创赛官网了解更多</a
              >
            </div>
          </el-row>
        </el-row>
      </el-row>

      <!-- 海云捷讯杯 -->
      <div id="awcloudCup">
        <div class="awcloudCup_center">
          <!-- 海云捷迅杯 -->
          <div class="awcloudCup_title">
            <div class="awcloudCup_titleTop">
              <div class="title-font28-0204">海云捷迅杯</div>
              <el-row class="title-bgimg-0204"></el-row>
            </div>
            <div class="awcloudCup_titleBottom">
              海云捷迅作为企业代表参与赛题设置，大赛中开设"海云捷迅杯"赛道
            </div>
          </div>
          <!-- 杯赛题目 -->
          <div class="awcloudCup_subject">
            <ul class="awcloudCup_subjectTop">
              <li class="awcloudCup_subjectTopLeft">
                <div class="awcloudCup_subjectImg"></div>
                <h3 class="awcloudCup_subjectTitle">杯赛题目</h3>
              </li>
              <li class="awcloudCup_subjectTopRight">
                <div class="awcloudCup_subjectImg"></div>
                <h3 class="awcloudCup_subjectTitle">参赛组别</h3>
              </li>
            </ul>
            <ul class="awcloudCup_subjectBottom">
              <li class="awcloudCup_subjectBottomLeft">
                基于FPGA CNN加速器的SSD_MobileNetV1模型目标检测实现
              </li>
              <li
                class="awcloudCup_subjectBottomRight"
                style="color: #333; font-weight: bold; line-height: 34px"
              >
                A组、B组
              </li>
            </ul>
          </div>
          <!-- 设计任务 -->
          <div class="awcloudCup_task">
            <el-row class="content-col18" style="width: 100%; margin-bottom: 0">
              <div class="content-col18-bg"></div>
              <div>设计任务</div>
            </el-row>
            <ul class="awcloudCup_taskBottom">
              <li>
                1. 基于百度Paddle-lite
                v2.9框架(必须)、海云捷迅自研CNN加速器(可选，也可以使用自己设计的加速器)（包含卷积、DW卷积、RELU、RELU6、量化算法，其中量化是把计算好的32位定点转为浮点再转为8位定点输出）。
              </li>
              <li>
                2.
                基于该加速器Linux驱动示例，可以看到数据重整的方法。根据算子运行位置（PS、PL）的不同，参照驱动示例来重新排列数据。
              </li>
              <li>3. 基于VOC数据集进行训练。</li>
              <li>
                4. 对模型在要求的设计指标内进行各种优化操作，包括剪枝、量化等。
              </li>
              <li>5. 提出设计方案，实现并完成指定测试图片集的目标检测功能。</li>
              <li>
                6.
                基础部分60分（满足设计指标），附加部分40分（在满足设计指标的情况下，按照推理速度进行评分）。最后总分按两部分相加得到。
              </li>
              <li>
                7. 备注：海云捷迅会提供（杯赛钉钉群内下载）：<br />
                1) FPGA配置文件 <br />
                2) CNN加速器相对应的Linux驱动示例 <br />
                3) Paddle-lite v2.9、SSD_MobileNetV1(全精度版本)
                的Demo程序；驱动示例；CNN加速器FPGA配置文件 <br />
              </li>
            </ul>
          </div>
          <!-- 设计指标 -->
          <div class="awcloudCup_task">
            <el-row class="content-col18" style="width: 100%; margin-bottom: 0">
              <div class="content-col18-bg"></div>
              <div>设计指标</div>
            </el-row>
            <ul class="awcloudCup_taskBottom">
              <li>1.模型部署完成，能正确识别图片数据</li>
              <li>2.帧率不低于2帧</li>
              <li>3.精度不低于百分之65</li>
            </ul>
          </div>
          <!-- 附加题 -->
          <div class="awcloudCup_task" style="padding-bottom: 45px">
            <el-row class="content-col18" style="width: 100%; margin-bottom: 0">
              <div class="content-col18-bg"></div>
              <div>附加题</div>
            </el-row>
            <ul class="awcloudCup_taskBottom" style="padding-bottom: 0">
              <li style="margin-bottom: 0">
                在满足设计指标的情况下，按照推理速度进行评分
              </li>
            </ul>
            <div class="awcloudCup_taskBottomTable">
              <table>
                <thead>
                  <tr>
                    <th class="awcloudCup_taskBottomPerformance">
                      性能/帧率(FPS)
                    </th>
                    <th class="awcloudCup_taskBottomScore">分值</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>2.5</td>
                    <td>10</td>
                  </tr>
                  <tr>
                    <td>3</td>
                    <td>13</td>
                  </tr>
                  <tr>
                    <td>3.5</td>
                    <td>16</td>
                  </tr>
                  <tr>
                    <td>4</td>
                    <td>20</td>
                  </tr>
                  <tr>
                    <td>4.5</td>
                    <td>22</td>
                  </tr>
                  <tr>
                    <td>5</td>
                    <td>24</td>
                  </tr>
                </tbody>
              </table>
              <table>
                <thead>
                  <tr>
                    <th class="awcloudCup_taskBottomPerformance">
                      性能/帧率(FPS)
                    </th>
                    <th class="awcloudCup_taskBottomScore">分值</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>6</td>
                    <td>26</td>
                  </tr>
                  <tr>
                    <td>7</td>
                    <td>28</td>
                  </tr>
                  <tr>
                    <td>8</td>
                    <td>30</td>
                  </tr>
                  <tr>
                    <td>9</td>
                    <td>35</td>
                  </tr>
                  <tr>
                    <td>10</td>
                    <td>40</td>
                  </tr>
                  <tr></tr>
                </tbody>
              </table>
            </div>
          </div>
          <!-- 提交内容 -->
          <div class="awcloudCup_task">
            <el-row class="content-col18" style="width: 100%; margin-bottom: 0">
              <div class="content-col18-bg"></div>
              <div>提交内容</div>
            </el-row>
            <ul class="awcloudCup_taskBottom">
              <li>1. 汇报PPT：项目介绍、关键技术介绍、性能指标</li>
              <li>2. 详细设计方案：系统架构分析、关键技术分析、性能分析</li>
              <li>3. 工程源码、仿真以及测试报告</li>
            </ul>
          </div>
          <!-- 评分标准 -->
          <div
            class="awcloudCup_task"
            style="margin-bottom: 60px; padding-bottom: 45px"
          >
            <el-row class="content-col18" style="width: 100%; margin-bottom: 0">
              <div class="content-col18-bg"></div>
              <div>评分标准</div>
            </el-row>
            <!-- 评分标准表 -->
            <div class="awcloudCup_SorePip">
              <table>
                <thead>
                  <tr>
                    <th class="awcloudCup_SorePipContent">内容</th>
                    <th class="awcloudCup_SorePipSore">分值</th>
                    <th class="awcloudCup_SorePipRequire">评分要求</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td rowspan="2" class="awcloudCup_SorePipBac">
                      1.性能指标
                    </td>
                    <td rowspan="2" class="awcloudCup_SorePipBac">30分</td>
                    <td>1.能正确的实现模型部署，并达到2帧要求。15分</td>
                  </tr>
                  <tr>
                    <td>2.精度不低于65%。15分</td>
                  </tr>
                  <tr>
                    <td rowspan="3" class="awcloudCup_SorePipBac">
                      2.设计完整性
                    </td>
                    <td rowspan="3" class="awcloudCup_SorePipBac">15分</td>
                    <td>1.完整的设计方案。5分</td>
                  </tr>
                  <tr>
                    <td>2.完整的源码工程以及注释。5分</td>
                  </tr>
                  <tr>
                    <td>3.完整的仿真以及测试报告。5分</td>
                  </tr>
                  <tr>
                    <td rowspan="3" class="awcloudCup_SorePipBac">
                      3.文档质量
                    </td>
                    <td rowspan="3" class="awcloudCup_SorePipBac">15分</td>
                    <td>1. 汇报PPT重点突出、条理清晰。5分</td>
                  </tr>
                  <tr>
                    <td>2. 设计方案原理分析合理、逻辑清晰。5分</td>
                  </tr>
                  <tr>
                    <td>
                      3、源码规范，注释清晰，仿真以及测试报告详细充分。5分
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <!-- <button class="awcloudCup_SorePipEnroll" style="outline: none;"
                onclick="javascript:window.open('https://www.saikr.com/vse/univ/ciciec/6','_blank')">立即报名海云捷迅杯</button> -->
          <el-row>
            <div
              style="margin: 60px 0; background-color: #ccc"
              class="btn-gwbm"
            >
              报名已结束
            </div>
          </el-row>
        </div>
      </div>

      <!-- 赛题解析 -->
      <!-- <el-row class="pd60-0204" id="stdy-mlj" style="background-color: #f5f6f9">
        <el-row class="w1160-0204">
          <el-row class="title-font28-0204">赛题答疑</el-row>
          <el-row class="title-bgimg-0204"></el-row>
          <el-row>
            <ul style="display: flex; margin-top: 30px">
              <li class="stdy-li">
                <div class="fpga-bg-box stdy-style">
                  <img
                    class="stdy-img"
                    src="@/assets/myMatch/ciciec2022/stdy/stjx.png"
                    alt=""
                  />
                  <span class="stdy-title">赛题解析</span>
                </div>
                <a class="stdy-bottom-title" href="/FAQ/1.html">查看详情</a>
              </li>
              <li class="stdy-li">
                <div class="fpga-bg-box stdy-style">
                  <img
                    class="stdy-img"
                    src="@/assets/myMatch/ciciec2022/stdy/demo.png"
                    alt=""
                  />
                  <span class="stdy-title">Demo</span>
                </div>
                <a class="stdy-bottom-title" href="/FAQ/2.html">查看详情</a>
              </li>
              <li class="stdy-li">
                <div class="fpga-bg-box stdy-style">
                  <img
                    class="stdy-img"
                    src="@/assets/myMatch/ciciec2022/stdy/tjlc.png"
                    alt=""
                  />
                  <span class="stdy-title">作品提交流程</span>
                </div>
                <a class="stdy-bottom-title" href="/FAQ/3.html">查看详情</a>
              </li>
              <li class="stdy-li" style="margin-right: 0px">
                <div class="fpga-bg-box stdy-style">
                  <img
                    class="stdy-img"
                    src="@/assets/myMatch/ciciec2022/stdy/zysx.png"
                    alt=""
                  />
                  <span class="stdy-title">注意事项及答疑内容归纳</span>
                </div>
                <a class="stdy-bottom-title" href="/FAQ/4.html">查看详情</a>
              </li>
            </ul>
          </el-row>
        </el-row>
      </el-row> -->

      <!-- FPGA培训 -->
      <el-row class="pd60-0204 fpga-wrapper" id="fpga-mlj">
        <el-row class="w1160-0204">
          <el-row class="title-font28-0204">FPGA培训</el-row>
          <el-row class="title-bgimg-0204"></el-row>
          <el-row class="title-text-fpga">
            FPGA培训以FPGA人工智能方向为主，依托业内领先的FPGA技术，为人工智能及大数据、云计算等关联领域培养技能型人才。
            培训以企业全案例训练为主要特色，面向学员有针对性的提供FPGA培训课程，课程直切企业需求，培养软件+硬件复合型人才，旨在为行业培养实战型专业人才。
            FPGA培训将就业贯穿学员培养的全过程，实现学员个人职业生涯的可持续发展；依托海云捷迅人工智能领域的合作伙伴及FPGA生态企业，组织专场招聘会和双选会，为企业输送优秀人才，保障学员就业
          </el-row>
          <el-row>
            <ul style="display: flex; margin-top: 30px">
              <li class="fpga-li">
                <div class="fpga-bg-box fpga-bg-one"></div>
                <div class="fpga-bottom-title">课堂教学</div>
              </li>
              <li class="fpga-li">
                <div class="fpga-bg-box fpga-bg-two"></div>
                <div class="fpga-bottom-title">专场招聘</div>
              </li>
              <li class="fpga-li">
                <div class="fpga-bg-box fpga-bg-three"></div>
                <div class="fpga-bottom-title">生活学习</div>
              </li>
              <li class="fpga-li" style="margin-right: 0px">
                <div class="fpga-bg-box fpga-bg-four"></div>
                <div class="fpga-bottom-title">素质拓展</div>
              </li>
            </ul>
          </el-row>
          <el-row style="margin-top: 30px">
            <div class="title-button">
              <a href="https://fpgaba.com/" target="_blank" class="title-link"
                >了解更多培训信息</a
              >
            </div>
          </el-row>
        </el-row>
      </el-row>
      <!-- 实训场景 -->
      <el-row class="pd60-0204 sx-wrapper" id="sxcj-mlj">
        <el-row class="w1160-0204">
          <el-row class="title-font28-0204">实训场景</el-row>
          <el-row class="title-bgimg-0204"></el-row>
          <el-row class="sx-box">
            <div class="sx-left sx-bg-one"></div>
            <div class="sx-right">
              <el-row
                class="content-col18"
                style="width: 100%; margin-bottom: 0"
              >
                <div class="content-col18-bg"></div>
                <div>农业智联网实训沙盘</div>
              </el-row>
              <div class="sx-title">
                农业智联网实训场景是以农业大棚为背景定制的一套微缩立体沙盘，涵盖人工智能、物联网、FPGA、Web开发等技术领域，
                可实现包括人工智能机器视觉技术的农作物病害检测、传感器数据收集及分析、FPGA入侵检测和反向自动控制等功能。
                通过可视化的监控大屏、移动端APP实现对大棚环境实时显示、状态查询、远程控制等操作。结合教学内容与实际产业、岗位需求，
                该实训套件能提供丰富的实验课程及配套资源，让学生快速掌握相关技能知识，加强对行业需求的理解和认知。
              </div>
            </div>
          </el-row>
          <el-row class="sx-box">
            <div class="sx-left sx-bg-two"></div>
            <div class="sx-right">
              <el-row
                class="content-col18"
                style="width: 100%; margin-bottom: 0"
              >
                <div class="content-col18-bg"></div>
                <div>工业缺陷检测实训套件</div>
              </el-row>
              <div class="sx-title">
                工业缺陷检测实训套件是以工业互联网铝表面缺陷检测应用为背景，面向高校人工智能、FPGA等相关专业的实训产品。
                为贴合真实应用场景，本产品加入专业的工业相机、光源、传送带、机械臂形成一套完整的智能检测应用系统，实现基于FPGA的数据推理、机械臂自动分拣和检测数据可视化展示等功能。
                产品利用YOLOv3深度学习算法和铝片表面缺陷数据集，并使用FPGA来运行模型应用，可检测铝表面划痕、针孔、褶皱、污损等4种缺陷类型，用户可二次开发增加缺陷种类。
              </div>
            </div>
          </el-row>
          <el-row class="sx-box" v-if="showMore">
            <div class="sx-left sx-bg-three"></div>
            <div class="sx-right">
              <el-row
                class="content-col18"
                style="width: 100%; margin-bottom: 0"
              >
                <div class="content-col18-bg"></div>
                <div>农业智联网实训套件</div>
              </el-row>
              <div class="sx-title">
                农业智联网实训套件结合传感器数据采集、数据传输、图像处理、智能化分析、反向自动控制等技术，通过监控大屏对农作物环境信息进行可视化展示，
                并将历史环境数据生成曲线走势图，方便用户直观了解环境变化趋势，也可以通过监控大屏的灯光控制按钮反向控制灯光照明。
                针对农作物种植过程中的病害问题，使用农作物病害样本集，基于YOLOv3算法模型训练得到农作物病害识别的智能算法模型，利用VPU芯片进行农作物病害实时检测并在大屏中展示检测结果，显示病因并提出防治方法。
              </div>
            </div>
          </el-row>
          <el-row class="sx-box" v-if="showMore">
            <div class="sx-left sx-bg-four"></div>
            <div class="sx-right">
              <el-row
                class="content-col18"
                style="width: 100%; margin-bottom: 0"
              >
                <div class="content-col18-bg"></div>
                <div>病害检测系统</div>
              </el-row>
              <div class="sx-title">
                病害检测系统是以农作物健康状态检测为背景，基于人工智能技术方向提供的软硬一体化实训产品。
                产品使用农作物病害样本集，利⽤YOLOv3⽬标检测算法进行训练，将最终输出模型作为系统的检测分类器，通过VPU芯片对农作物病害情况进行实时检测。
                当摄像头采集到农作物叶子图像时，系统可自动判叶子的种类及病害情况，并在Web页面对病害状况进行可视化展示。
                对有病害的农作物，通过文字标注相应的病害名称和防治方法，帮助农户做好病害预警。
              </div>
            </div>
          </el-row>
          <el-row class="sx-box" v-if="showMore">
            <div class="sx-left sx-bg-five"></div>
            <div class="sx-right">
              <el-row
                class="content-col18"
                style="width: 100%; margin-bottom: 0"
              >
                <div class="content-col18-bg"></div>
                <div>无人车实训套件</div>
              </el-row>
              <div class="sx-title">
                无人车实训套件是集自动控制、人工智能、FPGA、视觉计算等技术领域，面向高校人工智能相关专业提供的软硬一体的教学实训产品。
                系统搭载ARM、GPU、FPGA三大异构算力芯片，整合了ROS机器人操作系统平台，利用雷达测距原理、SLAM即时定位与地图构建、视觉计算、深度学习技术，
                实现无人车自动驾驶、交通标识牌识别、路径规划、目标跟踪等功能。
                支持通过手机APP对无人车进行状态查询和线路构建。
              </div>
            </div>
          </el-row>
          <el-row class="sx-box" v-if="showMore">
            <div class="sx-left sx-bg-six"></div>
            <div class="sx-right">
              <el-row
                class="content-col18"
                style="width: 100%; margin-bottom: 0"
              >
                <div class="content-col18-bg"></div>
                <div>画像风格迁移系统</div>
              </el-row>
              <div class="sx-title">
                画像风格迁移系统内置画像风格迁移（Fast-style-transfer）算法，对摄像头采集的真实图像和输入的风格图像通过神经网络深度运算，渲染成具有艺术风格迁移的图像，
                并通过画屏对风格迁移后的画像进行可视化展示。用户可通过照片打印机，对渲染后的画像快速打印成照片用作留念。结合该产品，可以帮助学生掌握画像风格迁移基础知识，熟悉模型依赖环境，
                了解模型推理过程，学习处理数据集方法，加深对图像处理、人工智能等技术的理解和认知。
              </div>
            </div>
          </el-row>
          <el-row
            style="
              margin-top: 30px;
              display: flex;
              justify-content: center;
              align-items: center;
            "
          >
            <div class="sx-botton" @click="showMore = !showMore">{{showMore ? '收起': '展开更多'}}</div>
            <img
              v-if="!showMore"
              src="@/assets/myMatch/ciciec2022/sxcj_btn_unfold.png"
              alt=""
              class="sxcj-btn-unfold"
            />
            <img
              v-if="showMore"
              src="@/assets/myMatch/ciciec2022/sxcj_btn_fold.png"
              alt=""
              class="sxcj-btn-fold"
            />
          </el-row>
        </el-row>
      </el-row>
      <!-- 赛事平台 -->
      <el-row class="pd60-0204 sspt-wrapper" id="sspt-mlj">
        <el-row class="w1160-0204">
          <el-row class="title-font28-0204">赛事平台</el-row>
          <el-row class="title-bgimg-0204"></el-row>
          <el-row class="title-text-0204"
            >海云捷迅提供人工智能边缘实验平台作为本次大赛的赛事平台</el-row
          >
          <el-row class="content-col18">
            <div class="content-col18-bg"></div>
            <div>赛事平台-人工智能边缘实验平台</div>
          </el-row>
          <el-row class="font14-0204 mgb10-0204"
            >该平台是由海云捷迅研发的云+FPGA+AI综合性平台</el-row
          >
          <el-row class="content-col14 mgb10-0204">
            <div class="content-col14-bg"></div>
            <div class="font14-0204">
              云端访问，使用SoC网络技术和FPGA远程调试技术，通过云端向参赛队伍提供服务，参赛队伍可以远程接入此平台，仿真、调试。
            </div>
          </el-row>
          <el-row class="content-col14 mgb10-0204">
            <div class="content-col14-bg"></div>
            <div class="font14-0204">
              FPGA，自主研发的人工智能边缘实验平台，将多个FPGA板卡放置在同一个机箱中，为其提供电源接口、网络分配管理单元，形成FPGA资源池，板卡使用的C5
              SoC的FPGA。
            </div>
          </el-row>
          <el-row class="content-col14">
            <div class="content-col14-bg"></div>
            <div class="font14-0204">
              AI，FPGA开发板内置了与百度开源深度学习Paddle-Paddle框架对接的驱动以及FPGA加速器Demo文件，参赛团队可以方便的将模型文件部署到结合Paddle-Paddle框架的FPGA上，
            </div>
          </el-row>
          <el-row class="font14-0204" style="margin-bottom: 30px"
            >测试其效果并调优。</el-row
          >
          <el-row class="sspt-bg-1"> </el-row>
          <el-row class="sspt-bottom clearfix">
            <div>
              <el-row class="content-col18">
                <div class="content-col18-bg"></div>
                <div>人工智能一体机解决方案</div>
              </el-row>
              <el-row class="content-col14 mgb10-0204">
                <div class="content-col14-bg"></div>
                <div class="font14-0204">
                  提供人工智能模型训练，用于端到端的实训场景
                </div>
              </el-row>
              <el-row class="content-col14 mgb10-0204">
                <div class="content-col14-bg"></div>
                <div class="font14-0204">
                  人工智能专业的开箱即用一站式解决方案
                </div>
              </el-row>
              <el-row class="content-col14 mgb10-0204">
                <div class="content-col14-bg"></div>
                <div class="font14-0204">提供适用的实验与科研环境</div>
              </el-row>
              <el-row class="content-col14 mgb10-0204">
                <div class="content-col14-bg"></div>
                <div class="font14-0204">提升学生动手操作、项目实践能力</div>
              </el-row>
            </div>
            <div class="sspt-bg-2"></div>
          </el-row>
        </el-row>
      </el-row>
      <!-- 应用示例 -->
      <el-row class="pd60-0204 yysl-wrapper" id="yysl-mlj">
        <el-row class="w1160-0204">
          <el-row class="title-font28-0204">应用示例</el-row>
          <el-row class="title-bgimg-0204"></el-row>
          <el-row class="title-text-0204"
            >赛事平台应用示例介绍，包括高校应用及产品应用</el-row
          >
          <el-row class="yysl1">
            <div style="margin-right: 95px">
              <el-row class="content-col18">
                <div class="content-col18-bg"></div>
                <div>高校应用</div>
              </el-row>
              <el-row class="font14-0204 mgb10-0204" style="width: 380px">
                电子科技大学&nbsp;&nbsp;重庆大学&nbsp;&nbsp;重庆邮电大学&nbsp;&nbsp;重庆交通大学&nbsp;&nbsp;</el-row
              >
            </div>
            <div class="yysl1-img-wrapper">
              <div class="yysl1-img1"></div>
              <div class="yysl1-img2"></div>
              <div class="yysl1-img3"></div>
            </div>
          </el-row>
          <el-row class="yysl1" style="margin-bottom: 0">
            <div style="margin-right: 110px">
              <el-row class="content-col18">
                <div class="content-col18-bg"></div>
                <div>产品应用</div>
              </el-row>
              <el-row class="font14-0204 mgb10-0204" style="width: 480px"
                >采用赛事平台的Demo工程，基于Mobilenet
                V1-SSD的物体分类模型，提供给参赛团队做参考，发挥同学们的创造力，给参赛团队更大的发挥空间。</el-row
              >
            </div>
            <div class="yysl1-img-wrapper">
              <div class="yysl1-img4"></div>
              <div class="yysl1-img5"></div>
            </div>
          </el-row>
        </el-row>
      </el-row>
    </div>
  </div>
</template>
<script>
import Swiper from "@/utils/swiper-bundle.min.js";
export default {
  data() {
    return {
      showMore: false,
      swiper: null,
    };
  },
  mounted() {
    this.initSwiper();
  },
  methods: {
    initSwiper() {
      this.swiper = new Swiper(".swiper-container", {
        modules: [Navigation],
        slidesPerView: 3,
        slidesPerGroup: 3,
        spaceBetween: 40,
        navigation: {
          prevEl: ".icon-fj-chevron-left",
          nextEl: ".icon-fj-chevron-right",
          disabledClass: "my-button-disabled",
        },
      });
    },
  },
};
</script>
<style scoped lang="less">
@import "@/less/swiper-bundle.min.css"; // 单独引入swiper样式防止冲突
</style>